export enum CustomControlEntity {
    DiagnosticReportAddEdit = 'DiagnosticReportAddEdit',
    DiagnosticReportRead = 'DiagnosticReportRead',
    ProcedureAddEdit = 'ProcedureAddEdit',
    ProcedureDiagnosticReportAddEdit = 'ProcedureDiagnosticReportAddEdit',
    ProcedureDiagnosticReportRead = 'ProcedureDiagnosticReportRead',
    ProcedureRead = 'ProcedureRead',
    RequestAddEdit = 'RequestAddEdit',
    RequestRead = 'RequestRead',
    SupervisionEdit = 'SupervisionEdit',
    SupervisionRead = 'SupervisionRead',
}
